import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth, formatApiErrorDetail } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Shell, GoogleButton } from "@/pages/Login";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await register(name, email, password);
      navigate("/onboarding", { replace: true });
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Shell title="Create your account" subtitle="Start practising thousands of past-paper questions.">
      <form onSubmit={submit} className="space-y-4" data-testid="register-form">
        <div className="space-y-2">
          <Label htmlFor="name">Full name</Label>
          <Input id="name" data-testid="register-name" value={name} onChange={(e) => setName(e.target.value)} required className="rounded-xl" placeholder="Aarav Sharma" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="email">Email</Label>
          <Input id="email" type="email" data-testid="register-email" value={email} onChange={(e) => setEmail(e.target.value)} required className="rounded-xl" placeholder="you@example.com" />
        </div>
        <div className="space-y-2">
          <Label htmlFor="password">Password</Label>
          <Input id="password" type="password" data-testid="register-password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={6} className="rounded-xl" placeholder="At least 6 characters" />
        </div>
        {error && <p className="text-sm text-red-500" data-testid="register-error">{error}</p>}
        <Button type="submit" disabled={loading} data-testid="register-submit" className="w-full rounded-xl py-6 text-base">
          {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />} Create account
        </Button>
      </form>
      <div className="my-6 flex items-center gap-3 text-xs uppercase tracking-widest text-muted-foreground">
        <div className="h-px flex-1 bg-border" /> or <div className="h-px flex-1 bg-border" />
      </div>
      <GoogleButton />
      <p className="mt-6 text-center text-sm text-muted-foreground">
        Already have an account?{" "}
        <Link to="/login" className="font-medium text-primary hover:underline" data-testid="go-login">Sign in</Link>
      </p>
    </Shell>
  );
}
